import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useHistory, useParams } from 'react-router-dom';
import { shouldShowPromoCodeMessage } from '../utils/helpers';
import PeacockSportsPass from '../assets/images/peacock-logo.svg';
import { fetchLeadSources } from '../services/fetchData';

import './PeacockSelection.scss';

const PeacockSelection = ({ oldSource }) => {
  const history = useHistory();
  const { leadSource } = useParams();
  const [source, setSource] = useState(oldSource);
  const [promoCodeMessageVisible, setPromoCodeMessageVisible] = useState(true);

  useEffect(async () => {
    if (!oldSource) {
      const { data } = await fetchLeadSources();
      const sourceObject = data.data.find(obj => obj.value === leadSource);
      if (sourceObject) {
        setSource(sourceObject.label);
      } else {
        history.push('/404');
      }
    }
  }, []);

  const closePromoCodeModal = () => setPromoCodeMessageVisible(false);

  const showPromoCode = promoCodeMessageVisible && source && shouldShowPromoCodeMessage();

  return (
    <div id="peacockContainer">
      <Dialog
        header="Concerned your device won't arrive on time?"
        visible={showPromoCode}
        draggable={false}
        resizable={false}
        focusOnShow={false}
        onMaskClick={closePromoCodeModal}
        onHide={closePromoCodeModal}
        footer={<Button label="Got it!" className="btn-magenta" onClick={closePromoCodeModal} />}>
        <p className="m-0">
          Upon sign-up you&apos;ll be provided with a back-up way to get the games using a Peacock insta-watch code so you
          don&apos;t miss a second of the action!
          <br />
          <b>
            Any orders after 5PM ET on Saturday are not guaranteed to be processed in time for the Chiefs vs. Dolphins Wild Card
            on January 13.
          </b>
        </p>
      </Dialog>
      <div className="container">
        {!source ? (
          <div className="flex justify-content-center align-items-center" style={{ width: '100%', height: '100vh' }}>
            <div className="flex align-self-center justify-content-center">
              <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em', color: '#FFFFFF' }} />
            </div>
          </div>
        ) : (
          <>
            <div className="header">
              <img className="logo" src={PeacockSportsPass} alt="Peacock Sports Pass" />
              <h2 className="mt-5">Get Started with Peacock Sports Pass</h2>
              <div className="underHeader">
                <div className="item">
                  <div className="bullet">1</div>Pick your package and place order
                </div>
                <div className="item">
                  <div className="bullet">2</div> Receive your commercial grade streaming device(s)
                </div>
                <div className="item">
                  <div className="bullet">3</div> Plug&apos;n Play Installation
                </div>
              </div>
            </div>
            <div className="grid justify-content-center">
              <Card className="col-6 mt-5 box">
                <div className="flex flex-column card_item_box">
                  <div>
                    <h2>Special Discount</h2>
                    <p>Get a Free UPshow Device!</p>
                    <p className="pUnderTitle">Peacock Sports Pass + FREE Device + UPshow Subscription</p>
                  </div>
                  <div className="rUnderTitle">
                    <div className="textmark">
                      <p>
                        <i className="pi pi-check p-mr-2" />
                        Full access to Peacock Sports Pass
                      </p>
                    </div>
                    <div className="textmark">
                      <p>
                        <i className="pi pi-check p-mr-2" />
                        No device fee on first device
                      </p>
                    </div>
                    <div className="textmark">
                      <p>
                        <i className="pi pi-check p-mr-2" />
                        Full access to UPshow Marketing & Entertainment Tools
                      </p>
                    </div>
                  </div>
                  <Button
                    label="Get Started"
                    className="btn-magenta"
                    onClick={() => {
                      history.push('/peacock-checkout', {
                        data: {
                          source,
                          selected: {
                            id: 'package_2',
                            title: 'Special Discount',
                            price: 75,
                            priceText: '$75/mo',
                            icon: '/static/media/starter.dc43f9b7.svg',
                            checklistP: ['Peacock Sports Pass + FREE Device(s) + UPshow Subscription'],
                            priceId: '',
                          },
                        },
                      });
                    }}
                  />
                </div>
              </Card>
              <Card className="col-6 mt-5 box">
                <div className="flex flex-column card_item_box">
                  <div className="title-card">
                    <h2>Standard</h2>
                    <p className="pUnderTitle">Peacock Sports Pass + Device Purchase + UPshow Free Trial</p>
                  </div>
                  <div className="rUnderTitle">
                    <div className="textmark">
                      {' '}
                      <i className="pi pi-check p-mr-2" />
                      Full access to Peacock Sports Pass
                    </div>
                    <div className="textmark">
                      {' '}
                      <i className="pi pi-check p-mr-2" />
                      $300 fee per device
                    </div>
                    <div className="textmark">
                      {' '}
                      <i className="pi pi-check p-mr-2" />
                      45 day UPshow Free Trial
                    </div>
                  </div>
                  <Button
                    label="Get Started"
                    className="btn-magenta"
                    onClick={() => {
                      history.push('/peacock-checkout', {
                        data: {
                          source,
                          selected: {
                            id: 'package_1',
                            title: 'Standard',
                            priceText: '$75/mo',
                            price: 75,
                            icon: '/static/media/starter.dc43f9b7.svg',
                            checklistP: ['Peacock Sports Pass + Device(s) Purchase + UPshow Free Trial'],
                            priceId: '',
                          },
                        },
                      });
                    }}
                  />
                </div>
              </Card>
            </div>
            <div className="contact-link">
              <p>Have Questions about Peacock Sports Pass?</p>
              <p>
                <a href="https://info.upshow.tv/peacock-sports-pass" target="#">
                  Check out this overview
                </a>{' '}
                or contact EverPass at <span className="bold-text">1-866-756-9387</span> ext. 812 or sales@everpass.com
              </p>
            </div>
            <p className="disclaimer">
              Peacock is a trademark of Peacock TV, LLC. <br />
              Programming, pricing, terms, and conditions subject to change. Peacock Sports Pass does not include all content
              otherwise available Peacock.TV for personal use, and programming will be subject to change.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

PeacockSelection.propTypes = {
  oldSource: PropTypes.string,
};

PeacockSelection.defaultProps = {
  oldSource: '',
};

export default PeacockSelection;
